var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { SET_PARSED_SCHEMA, SET_SCHEMA, SET_TASK_ELEMENT_ERRORS, SET_JOB_ELEMENT_ERRORS, SET_SCHEMA_ELEMENT_VALUE, UPDATE_JOB_ELEMENTS_VALUES, UPDATE_SCHEMA_ELEMENT_VALUE, UPDATE_TASK_ELEMENTS_VALUES, STORE_EDITOR_REFERENCES, SET_JOB_ELEMENTS_VALUES, SET_TASK_ELEMENTS_VALUES, } from "../actions/availableActions";
var initialState = {
    schemas: {},
    parsedSchemas: {},
    elementsValuesMap: {},
    validationErrorsMap: {},
    instructions: {}
};
var schemaReducer = function (state, action) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case SET_SCHEMA:
            return __assign(__assign({}, state), { schemas: __assign(__assign({}, state.schemas), (_a = {}, _a[action.payload.schemaId] = action.payload.schema, _a)) });
        case SET_PARSED_SCHEMA:
            return __assign(__assign({}, state), { parsedSchemas: __assign(__assign({}, state.parsedSchemas), (_b = {}, _b[action.payload.schemaKey] = action.payload.schema, _b)) });
        case STORE_EDITOR_REFERENCES:
            var _t = action.payload, schemaKey = _t.schemaKey, editorReferences = _t.editorReferences;
            return __assign(__assign({}, state), { instructions: __assign(__assign({}, state.instructions), (_c = {}, _c[schemaKey] = editorReferences, _c)) });
        case SET_SCHEMA_ELEMENT_VALUE: {
            var _u = action.payload, schemaKey_1 = _u.schemaKey, values = _u.values;
            return __assign(__assign({}, state), { elementsValuesMap: __assign(__assign({}, state.elementsValuesMap), (_d = {}, _d[schemaKey_1] = values, _d)) });
        }
        case UPDATE_SCHEMA_ELEMENT_VALUE: {
            var _v = action.payload, schemaKey_2 = _v.schemaKey, values = _v.values;
            return __assign(__assign({}, state), { elementsValuesMap: __assign(__assign({}, state.elementsValuesMap), (_e = {}, _e[schemaKey_2] = __assign(__assign({}, state.elementsValuesMap[schemaKey_2]), values), _e)) });
        }
        case UPDATE_TASK_ELEMENTS_VALUES: {
            var _w = action.payload, schemaKey_3 = _w.schemaKey, metadataId = _w.metadataId, values = _w.values;
            var schemaValues = state.elementsValuesMap[schemaKey_3] || {};
            var taskElementsValues = schemaValues.taskElementsValues || {};
            var elementsValues = taskElementsValues[metadataId];
            var newElementsValues = __assign(__assign({}, elementsValues), values);
            return __assign(__assign({}, state), { elementsValuesMap: __assign(__assign({}, state.elementsValuesMap), (_f = {}, _f[action.payload.schemaKey] = __assign(__assign({}, schemaValues), { taskElementsValues: __assign(__assign({}, taskElementsValues), (_g = {}, _g[metadataId] = newElementsValues, _g)) }), _f)) });
        }
        case SET_TASK_ELEMENTS_VALUES: {
            var _x = action.payload, schemaKey_4 = _x.schemaKey, metadataId = _x.metadataId, values = _x.values;
            var schemaValues = state.elementsValuesMap[schemaKey_4] || {};
            var taskElementsValues = schemaValues.taskElementsValues || {};
            return __assign(__assign({}, state), { elementsValuesMap: __assign(__assign({}, state.elementsValuesMap), (_h = {}, _h[action.payload.schemaKey] = __assign(__assign({}, schemaValues), { taskElementsValues: __assign(__assign({}, taskElementsValues), (_j = {}, _j[metadataId] = values, _j)) }), _h)) });
        }
        case SET_JOB_ELEMENTS_VALUES: {
            var _y = action.payload, schemaKey_5 = _y.schemaKey, metadataId = _y.metadataId, values = _y.values;
            var schemaValues = state.elementsValuesMap[schemaKey_5] || {};
            var jobElementsValues = schemaValues.jobElementsValues || {};
            return __assign(__assign({}, state), { elementsValuesMap: __assign(__assign({}, state.elementsValuesMap), (_k = {}, _k[action.payload.schemaKey] = __assign(__assign({}, schemaValues), { jobElementsValues: __assign(__assign({}, jobElementsValues), (_l = {}, _l[metadataId] = values, _l)) }), _k)) });
        }
        case UPDATE_JOB_ELEMENTS_VALUES: {
            var _z = action.payload, schemaKey_6 = _z.schemaKey, metadataId = _z.metadataId, values = _z.values;
            var schemaValues = state.elementsValuesMap[schemaKey_6] || {};
            var jobElementsValues = schemaValues.jobElementsValues || {};
            var elementsValues = jobElementsValues[metadataId];
            var newElementsValues = __assign(__assign({}, elementsValues), values);
            return __assign(__assign({}, state), { elementsValuesMap: __assign(__assign({}, state.elementsValuesMap), (_m = {}, _m[action.payload.schemaKey] = __assign(__assign({}, schemaValues), { jobElementsValues: __assign(__assign({}, jobElementsValues), (_o = {}, _o[metadataId] = newElementsValues, _o)) }), _m)) });
        }
        case SET_TASK_ELEMENT_ERRORS: {
            var _0 = action.payload, schemaKey_7 = _0.schemaKey, metadataId = _0.metadataId, validationErrors = _0.validationErrors;
            var schemaErrors = state.validationErrorsMap[schemaKey_7] || {};
            var taskErrors = schemaErrors.taskErrors || {};
            return __assign(__assign({}, state), { validationErrorsMap: __assign(__assign({}, state.validationErrorsMap), (_p = {}, _p[schemaKey_7] = __assign(__assign({}, schemaErrors), { taskErrors: __assign(__assign({}, taskErrors), (_q = {}, _q[metadataId] = validationErrors, _q)) }), _p)) });
        }
        case SET_JOB_ELEMENT_ERRORS: {
            var _1 = action.payload, schemaKey_8 = _1.schemaKey, metadataId = _1.metadataId, validationErrors = _1.validationErrors;
            var schemaErrors = state.validationErrorsMap[schemaKey_8] || {};
            var jobErrors = schemaErrors.jobErrors || {};
            return __assign(__assign({}, state), { validationErrorsMap: __assign(__assign({}, state.validationErrorsMap), (_r = {}, _r[schemaKey_8] = __assign(__assign({}, schemaErrors), { jobErrors: __assign(__assign({}, jobErrors), (_s = {}, _s[metadataId] = validationErrors, _s)) }), _r)) });
        }
        default:
            return state;
    }
};
export default schemaReducer;
